export default __webpack_public_path__ + "static/media/kitchen2-1024w.6d632ef6.avif";